import { Game } from "@/scene";
import { Assets } from "@/utils/assets";
import Phaser from "phaser";

export default class Cupid extends Phaser.Physics.Arcade.Sprite{

    private gamescene?: Game;

    constructor(scene: Phaser.Scene){
        super(scene, 0, 0, Assets.GAME.ID, 'cupid.png');
        scene.add.existing(this);
        scene.physics.add.existing(this).setImmovable(true);
        this.setScrollFactor(0);
        this.gamescene = scene as Game;
    }

    public update(): void{
        this.refreshBody();
        this.setBodySize(this.width * 0.6, this.height * 0.6);
    }
}